import React, { useEffect, useState } from "react";
import ButtonBack from "../../../../components/Buttons/Back";
import Loader from '../../../../components/Loader';

import { useParams } from "react-router-dom";

import {
    getConcesionarios,
} from "../../../../API/CitasServicioRequest/index";
import { getOnlyAudiCenters } from "../../../../utilities/utils";

const ThankYou = () => {
    const { concesionaria } = useParams();

    const [loading, setLoading] = useState(false);
    const [urlHomeDealer, setUrlHomeDealer] = useState('');

    useEffect(() => {
        document.title = "Gracias - Prueba de manejo";
        window.scrollTo(0, 0);
        setLoading(true);

        const funGetConcesionarios = async () => {
            try {
                const responseConcesionarios = await getConcesionarios();
                const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);
                if (concesionaria === undefined) {
                    /**
                     * Envia evento de analytics de Form Prueba de manejo
                     */
                    console.log("Es form general");
                } else {
                    /**
                     * Busca si el parametro pertenece a algun concesionario
                     */
                    const concesionarioActual = filterConcesionarios.find((dealer) => parseInt(concesionaria) === dealer.dealerNumber);
                    if (concesionarioActual) {
                        /**
                         * Si existe el concesionario en el listado
                         * Agregamos la informacion al store
                         */
                        // console.log(concesionarioActual);
                        setUrlHomeDealer(getHomeConcesionaria(concesionarioActual));
                        setLoading(false);

                    } else {
                        /**
                         * No se encuentra el concesionaria, se borra el parametro y se muestra el form general
                         */
                        throw new Error("No se encontro la información del concesionario");
                    }
                }

                return filterConcesionarios;
            } catch (error) {
                console.error("Obtener concesionarios: ", error);
                throw error;
            }

        };
        funGetConcesionarios();
    }, [concesionaria]);

    const getHomeConcesionaria = (concesionarioActual) => {

        if (concesionarioActual?.contactos === null) return ""

        const urlHomeConcesionaria = concesionarioActual?.contactos.split(",").length > 8 ? concesionarioActual?.contactos.split(",")[0].split(";").map(item => item.trim()) : "";

        return urlHomeConcesionaria[0];
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="">
                <div className="container mt-4 mb-4 w-100">
                    <ButtonBack pagesToBack={1} />
                </div>
                <section className="container pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando tu solicitud. Un asesor de nuestro equipo se pondrá en contacto contigo a la brevedad.</p>
                            <div className="d-flex justify-content-center mb-5 pb-5">
                                <a className='button-home mt-5 mb-5' href={urlHomeDealer} target="_parent">
                                    Volver al Home
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYou;